import { Card, Link, Typography } from '@mui/material';
import { PATH_DASHBOARD } from 'routes/paths';
import { useTranslator } from 'translation/useTranslator';

export const NoLicenseCard = () => {
  const translator = useTranslator();
  return (
    <Card sx={{ p: 3 }}>
      <Typography>{translator.orgHasNoLicense()}</Typography>
      <Link href={`${PATH_DASHBOARD.admin.root}/license`}>
        {translator.createLicenseHelpText()}
      </Link>
    </Card>
  );
};
